document.addEventListener('DOMContentLoaded', function () {
  function openCartDrawer() {
    const cartDrawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.show === 'function') {
      cartDrawer.show();
      return;
    }

    const cartTrigger = document.querySelector('[aria-controls="cart-drawer"]');

    if (cartTrigger) {
      cartTrigger.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );
    }
  }

  document.addEventListener('variant:add', function (event) {
    if (window.themeVariables?.settings?.cartType === 'page') return;
    if (event.detail?.blockCartDrawerOpening) return;

    openCartDrawer();
  });

  const wrappers = document.querySelectorAll('[data-product-gate-wrapper="true"]');

  wrappers.forEach((wrapper) => {
    const formId = wrapper.dataset.formId;
    const modalId = wrapper.dataset.modalId;

    const form = document.getElementById(formId);
    const modal = document.getElementById(modalId);

    if (!form || !modal) return;

    const backButton = modal.querySelector('[data-modal-back]');
    const nextButton = modal.querySelector('[data-modal-next]');
    const progress = modal.querySelector('[data-modal-progress]');
    const checks = Array.from(modal.querySelectorAll('.pre-venda-check__input'));

    if (!form || !modal || !backButton || !nextButton || !progress) return;

    let liberado = false;
    let currentStep = 1;
    const totalSteps = 3;
    let pendingSubmitter = null;

    function getSubmitButtons() {
      return [
        ...document.querySelectorAll(`button[form="${formId}"][type="submit"]`),
        ...document.querySelectorAll(`input[form="${formId}"][type="submit"]`),
        ...form.querySelectorAll('button[type="submit"], input[type="submit"]')
      ];
    }

    function isSubmitButton(target) {
      const btn = target.closest('button, input[type="submit"]');
      if (!btn) return false;

      if (btn.matches(`button[form="${formId}"][type="submit"], input[form="${formId}"][type="submit"]`)) {
        return true;
      }

      if (form.contains(btn) && btn.matches('button[type="submit"], input[type="submit"]')) {
        return true;
      }

      return false;
    }

    function openModal() {
      currentStep = 1;
      checkboxReset();
      updateUI();
      modal.classList.remove('hidden');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pre-venda-modal-open');
    }

    function closeModal() {
      modal.classList.add('hidden');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pre-venda-modal-open');
      currentStep = 1;
      checkboxReset();
      updateUI();
    }

    function checkboxReset() {
      checks.forEach((check) => {
        check.checked = false;
      });
    }

    function allChecked() {
      return checks.length > 0 && checks.every((check) => check.checked);
    }

    function updateIndicators() {
      modal.querySelectorAll('[data-step-indicator]').forEach((item) => {
        const step = Number(item.getAttribute('data-step-indicator'));
        item.classList.remove('is-active', 'is-done');

        if (step === currentStep) {
          item.classList.add('is-active');
        } else if (step < currentStep) {
          item.classList.add('is-done');
        }
      });
    }

    function updateContents() {
      modal.querySelectorAll('[data-step-content]').forEach((item) => {
        const step = Number(item.getAttribute('data-step-content'));
        item.classList.toggle('is-active', step === currentStep);
      });
    }

    function updateButtons() {
      backButton.style.display = currentStep > 1 ? 'inline-flex' : 'none';
      progress.textContent = `Etapa ${currentStep} de ${totalSteps}`;

      nextButton.classList.remove('pre-venda-btn--primary', 'pre-venda-btn--success');

      if (currentStep < totalSteps) {
        nextButton.textContent = 'Entendi, avançar →';
        nextButton.classList.add('pre-venda-btn--primary');
        nextButton.disabled = false;
      } else {
        nextButton.textContent = 'Confirmar e continuar ✓';
        nextButton.classList.add('pre-venda-btn--success');
        nextButton.disabled = !allChecked();
      }
    }

    function updateUI() {
      updateIndicators();
      updateContents();
      updateButtons();
    }

    function continueToBuy() {
      liberado = true;
      closeModal();
      const submitter = pendingSubmitter && document.contains(pendingSubmitter) ? pendingSubmitter : getSubmitButtons()[0];
      pendingSubmitter = null;

      const handleVariantAdded = function () {
        openCartDrawer();
        form.removeEventListener('variant:add', handleVariantAdded);
      };

      form.addEventListener('variant:add', handleVariantAdded, { once: true });

      if (submitter && typeof submitter.click === 'function') {
        submitter.click();
      } else if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.submit();
      }

      setTimeout(() => {
        liberado = false;
      }, 400);
    }

    document.addEventListener(
      'click',
      function (event) {
        if (liberado) return;
        if (!isSubmitButton(event.target)) return;

        pendingSubmitter = event.target.closest('button, input[type="submit"]');

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        openModal();
      },
      true
    );

    form.addEventListener(
      'submit',
      function (event) {
        if (liberado) return;

        if (event.submitter) {
          pendingSubmitter = event.submitter;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        openModal();
      },
      true
    );

    modal.querySelectorAll('[data-pre-venda-close]').forEach((element) => {
      element.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        closeModal();
      });
    });

    checks.forEach((check) => {
      check.addEventListener('change', function () {
        if (currentStep === totalSteps) updateButtons();
      });
    });

    backButton.addEventListener('click', function (event) {
      event.preventDefault();
      if (currentStep > 1) {
        currentStep -= 1;
        updateUI();
      }
    });

    nextButton.addEventListener('click', function (event) {
      event.preventDefault();

      if (currentStep < totalSteps) {
        currentStep += 1;
        updateUI();
        return;
      }

      if (!allChecked()) return;

      continueToBuy();
    });

    updateUI();
  });
});
